import {
    FACETS_FAILURE,
    FILTER_UPDATED,
    SEARCH_TERM_UPDATED,
    FILTERS_SET_FROM_URL,
    QUERY_SET_FROM_URL,
    SEARCH_MODE_ENABLED,
    SEARCH_MODE_DISABLED,
    MAP_SHOWN,
    MAP_HIDDEN,
    SEARCH_CLEARED,
    PAGE_CHANGED,
    SET_SEARCH_DATA,
} from './types';
import { history } from 'cademy-shared-web';

export const loadFilters =
    (facetFilters, distinct = true) =>
    (dispatch) => {
        dispatch({ type: FACETS_FAILURE });
    };

export const updateFiltersFromQueryStrings =
    (queryParamsObj = {}) =>
    (dispatch) => {
        if (Object.values(queryParamsObj).some((val) => val !== null)) {
            dispatch(setSearchMode(true));
        }
        if (queryParamsObj.q) {
            dispatch({ type: QUERY_SET_FROM_URL, payload: queryParamsObj.q });
            delete queryParamsObj.q;
        }

        if (queryParamsObj.layout) {
            dispatch({ type: SET_SEARCH_DATA, payload: { layout: queryParamsObj.layout } });
        }

        if (queryParamsObj.map) {
            dispatch({ type: queryParamsObj.map === 'true' ? MAP_SHOWN : MAP_HIDDEN });
        }

        if (queryParamsObj.category_ref) {
            queryParamsObj.category_ref = decodeURIComponent(
                String(queryParamsObj.category_ref)
            ).split(',');
        }

        if (queryParamsObj.delivery) {
            queryParamsObj.delivery = String(queryParamsObj.delivery).split(',');
        }

        dispatch({ type: FILTERS_SET_FROM_URL, payload: queryParamsObj });

        dispatch(setPage(queryParamsObj.p ? queryParamsObj.p - 1 : 0));
    };

export const setFilters = (filter, values) => (dispatch) => {
    dispatch({
        type: FILTER_UPDATED,
        payload: { filter, values },
    });
    dispatch(updateQueryStringsFromFilters());
    dispatch(setPage(0));
};

export const setQuery = (searchInputValue) => (dispatch) => {
    dispatch({
        type: SEARCH_TERM_UPDATED,
        payload: searchInputValue,
    });
    dispatch(updateQueryStringsFromFilters());
    dispatch(setPage(0));
};

export const updateQueryStringsFromFilters = () => (dispatch, getState) => {
    let filters = getState().search.filters;
    let query = getState().search.query;
    let params = new URLSearchParams(history.location.search);
    for (const key in filters) {
        if (filters[key] !== null) {
            if (Array.isArray(filters[key])) {
                params.set(key, filters[key].join(','));
            }
            if (typeof key === 'number' || typeof key === 'string') {
                params.set(key, filters[key]);
            }
        } else {
            params.delete(key);
        }
    }
    if (String(query).length > 0) {
        params.set('q', query);
    }
    if (query === '') {
        params.delete('q');
    }
    if (params.toString().length) {
        dispatch(setSearchMode(true));
    } else {
        dispatch(setSearchMode(false));
    }
    history.replace({ search: params.toString() });
};

export const setSearchMode = (arg) => {
    if (arg === true) {
        return { type: SEARCH_MODE_ENABLED };
    }
    if (arg === false) {
        return { type: SEARCH_MODE_DISABLED };
    }
};

export const setMapMode = (arg) => (dispatch) => {
    let params = new URLSearchParams(history.location.search);
    params.set('map', arg);
    history.replace({ search: params.toString() });
    dispatch({ type: arg ? MAP_SHOWN : MAP_HIDDEN });
    if (arg) {
        dispatch(setSearchMode(true));
    }
};

export const clearSearch = () => (dispatch) => {
    dispatch({ type: SEARCH_CLEARED });
    dispatch(updateQueryStringsFromFilters());
};

export const setPage = (x) => (dispatch) => {
    let params = new URLSearchParams(history.location.search);

    params.set('p', Number(x) + 1);

    if (x === 0) {
        params.delete('p');
    }

    history.push({ search: params.toString() });

    dispatch({
        type: PAGE_CHANGED,
        payload: x,
    });
    // dispatch(doSearch());
};
